import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { formValidation } from '../../../utils/functions'
import Button from '../../button'
import FormFileInput from '../../form-file-input'
import CloseSVG from '../../../assets/svg/close.svg'
import { useHistory } from 'react-router-dom'
import { useRunAirtimeExcel } from '../../../redux/airtime/hook'
import FormInput from '../../form-input'
import DOMPurify from 'dompurify'
import Modal from '../modal'
import { useExportEmployees } from '../../../redux/employees/hook'
import Excel from 'exceljs'
import { saveAs } from 'file-saver'

function BulkPurchaseAirtime({ isOpen, closeModal, refresh }) {
  const { mutateAsync: runExcel, isLoading: excelLoading } =
    useRunAirtimeExcel()

  const {
    register,
    handleSubmit,
    errors,
    formState: { isValid },
  } = useForm({
    mode: 'onChange',
  })
  const history = useHistory()

  async function submitForm(data) {
    const desc = DOMPurify.sanitize(data?.desription)
    const formData = new FormData()
    formData.append('file', data?.file[0])
    formData.append('description', desc)

    await runExcel(formData).then((response) => {
      history.push(`/airtime/preview/${response.data.ref}`)
    })
  }
  const { mutateAsync: exportEmployee } = useExportEmployees()

  const [exportLoading, setSetExportLoading] = useState(false)
  const workbook = new Excel.Workbook()

  const columns = [
    { header: 'First Name', key: 'first_name' },
    { header: 'Last Name', key: 'last_name' },
    { header: 'Phone Number', key: 'mobile' },
    {
      header: 'Network (Lowercase eg. mtn)',
      key: 'network',
    },
    {
      header: 'Description',
      key: 'description',
    },

    {
      header: 'Amount',
      key: 'amount',
    },
  ]

  const exportTemplate = async () => {
    setSetExportLoading(true)
    let payload = {
      limit: 30,
      page: 1,
      statusFilter: -1,
      search: '',
    }
    await exportEmployee(payload).then(async (response) => {
      // let data = response?.data
      // Export only active employees
      let data = response?.data?.filter((item) => item.status === 1)
      const workSheetName = 'active_employee_data'
      const workBookName = `Airtime upload data (pre-filled)`
      try {
        const fileName = workBookName

        const worksheet = workbook.addWorksheet(workSheetName)

        // add worksheet columns
        // each columns contains header and its mapping key from data
        worksheet.columns = columns

        // updated the font for first row.
        worksheet.getRow(1).font = { bold: true }

        // loop through all of the columns and set the alignment with width.
        worksheet.columns.forEach((column) => {
          if (column._number > 5) {
            column.width = 25
            column.style.alignment = { horizontal: 'right' }
            column.numFmt = '0.00'
          } else {
            column.width = column.header.length + 2
            column.style.alignment = { horizontal: 'left' }
          }
        })
        data?.forEach((singleData) => {
          worksheet.addRow(singleData)
        })

        // loop through all of the rows and set the outline style.
        worksheet.eachRow({ includeEmpty: true }, (row) => {
          // store each cell to currentCell
          const currentCell = row._cells

          // loop through currentCell to apply border only for the non-empty cell of excel
          currentCell.forEach((singleCell) => {
            // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
            const cellAddress = singleCell._address

            worksheet.getCell(cellAddress).border = {
              top: { style: 'none' },
              left: { style: 'none' },
              bottom: { style: 'none' },
              right: { style: 'none' },
            }
          })
        })

        // write the content using writeBuffer
        const buf = await workbook.xlsx.writeBuffer()

        // download the processed file
        saveAs(new Blob([buf]), `${fileName}.xlsx`)
      } catch (error) {
        // console.error('<<<ERRROR>>>', error);
        // console.error('Something Went Wrong', error.message);
      } finally {
        workbook.removeWorksheet(workSheetName)
      }
    })
    setSetExportLoading(false)
  }

  return (
    <Modal
      scrollable={true}
      className='!max-w-[700px] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <div className='overflow-auto'>
        <div className='pl-8 pr-8 pt-4'>
          <div className='flex flex-row justify-between items-center'>
            <span className='header-4'>Purchase Bulk Airtime</span>
            <div className='cursor-pointer' onClick={() => closeModal()}>
              <img src={CloseSVG} alt='close' />
            </div>
          </div>
        </div>
        <hr className='divider' />
        <form className='form' onSubmit={handleSubmit(submitForm)}>
          <div className='flex flex-col px-8 pb-4 gap-3'>
            <div className='flex flex-col text-center justify-center items-center'>
              <span className='header-4-medium'>
                Upload Airtime from XLSX file
              </span>
              <div className=' flex flex-col border p-4 rounded-md bg-highlight mt-2 mb-3 justify-center items-center w-full'>
                <Button
                  text='Download template'
                  type='button'
                  theme='primary'
                  loading={exportLoading}
                  className='flex gap-2 !h-[35px] w-[220px] p-2 '
                  textClass={'!text-[11px]'}
                  onClick={() => {
                    exportTemplate()
                  }}
                />
              </div>
              <FormFileInput
                multiSource={true}
                inputRef={register(formValidation('file', true))}
                accept='.xlsx'
              />
            </div>
            <FormInput
              label='Description'
              name='desription'
              type='text'
              placeholder={'Enter description'}
              readOnly={excelLoading}
              error={errors.desription}
              errorMessage={errors.desription && errors.desription.message}
              inputRef={register(formValidation('text', true))}
            />

            <div className='w-full mt-[20px]'>
              <Button text='RUN AIRTIME' type='submit' loading={excelLoading} />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default BulkPurchaseAirtime
